import React, { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Loader } from '@/components/loader/loader';
import { AgentTypeEnum } from '@/types/agent';
import { parseParams } from '@/utils/searchParams';

import AgentAidp from './agentAidp';
import AgentLowCode from './agentLowCode';

export const dynamic = 'force-dynamic';

type SearchParams = {
  an: string;
  i?: string;
  t: AgentTypeEnum;
  v?: string;
  mockData?: string;
};

function AgentPlaygroundPage() {
  const [ searchParams ] = useSearchParams();
  const searchParamsParsed = parseParams<SearchParams>( searchParams );

  return searchParamsParsed.t === AgentTypeEnum.LOW_CODE
    ? <AgentLowCode { ...searchParamsParsed } />
    : <AgentAidp { ...searchParamsParsed } />;
};

export default function Page() {
  return (
    <Suspense fallback={ <Loader /> }>
      <AgentPlaygroundPage />
    </Suspense>
  );
}